import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";

export const Container = styled(FlexColumn)``;

export const Title = styled.h1`
    margin: 0 0 5px;
    ${setFontVariant("tooltip", colorsPalettes.bluegrey[100])};
`;

export const VideoThumbnail = styled.img`
    width: 198px;
    height: 116px;
    cursor: pointer;
`;

export const LeanMoreLink = styled.a`
    margin-top: 6px;
    ${setFontVariant("tooltip", colorsPalettes.blue[300])};
`;
